export default {
  warnings: {
    canNotAccessMicrophone: "Nemůžeme získat přístup k mikrofonu. Zkontrolujte, zda máte povolený přístup k mikrofonu a zkuste to znovu.",
    webspeechNotSupported: "Možnost diktování hlasem (Web Speech API) není umožněno v tomto prohlížeči.",
    speechToTextFailed: "Přepis řeči se nepodařilo dokončit. Zkuste to prosím znovu.",
    reEnableMicrophone: "Povolte prosím svůj mikrofon v prohlížeči.",
    notSupportedOnThisBrowser: "Tato funkce není podporována ve vašem prohlížeči.",
    notAllowed: "Nemáte povolení pro přístup na tuto stránku.",
    noGroupsAssigned: "Nejste přiřazeni do žádné skupiny. Kontaktujte správce organizace.",
    organizationHasNoContent: "Organizace/Skupina nemá žádný obsah. Prosím, kontaktujte správce organizace.",
    sessionExpired: "Vaše relace vypršela. Přihlaste se prosím znovu.",
    speechAi: "Hlas, který uslyšíte, je vygenerovaný umělou inteligencí.",
  },
  dictation: {
    durationLabel: "{elapsed} z {limit}",
    stopped: "Diktování bylo přerušeno.",
    stoppedMaxDuration: "Diktování bylo automaticky ukončeno po dosažení limitu {limit}.",
    stoppedSilence: "Diktování bylo automaticky ukončeno po {seconds} sekundách ticha.",
  },
  buttons: {
    back: "Zpět",
    analyze: "Vyhodnotit",
    showAnalysis: "Zobrazit mé hodnocení",
    support: "Podpora",
    close: "Zavřít",
    save: "Uložit",
    create: "Vytvořit",
    saving: "Ukládám...",
    cancel: "Zrušit",
    edit: "Upravit",
    delete: "Smazat",
    view: "Zobrazit",
  },
  termsLink: "https://www.provocator.ai/terms-of-use",
  gameStatuses: {
    completed: "Dokončeno",
    in_progress: "Započato",
    not_started: "Nezačato",
  },
  gameTypes: {
    gymShort: "Krátký gym",
    challange: "Modelová situace",
    gymLong: "Dlouhý gym",
  },
  others: {
    selected: "vybrán",
  },
};
